import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { DetailsDashboard } from "../../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { MODAL_CUSTOM_MESSAGE, Selected_Index, TABLE_PAGINATION_KEY } from "../../../../../constants/external-constants";
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { RequestHeaders } from "../../../../common/header-logo/request-header.component";
import Translation from "../../../../common/translation/translation.component";
import ModalContainer from "../../../../common/modal/modal-container/modal-container.component";
import DetailContainer from "../../../../common/Layout/details/DetailsLayout.component";
import ArticleDetails from "../modal-form/details/form/article-catalogue-details.component";
import "../modal-form/details/article.style.css";
import ArticleHistory from "../modal-form/history/article-history.component";
import { isObjectEqual } from "../../../../../utils/helpers.utils";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { TRANSLATIONS as translation } from "../../../../../utils/constant.utils";
import { articleCatalogueActions } from "../../../../../store/external/recharge-reducer/article-catalogue-reducer/article-catalogue.reducer";
import { articleCatalogueMilestoneActions } from "../../../../../store/external/recharge-reducer/article-catalogue-milestone.reducer/article-catalogue-milestone.reducer";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../utils/helpers.utils";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
class ArticleCatalogue extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.handleTabIcon = this.handleTabIcon.bind(this)
        this.handlePrimaryBtn = this.handlePrimaryBtn.bind(this)
        this.handleSecondary = this.handleSecondary.bind(this)
        this.ConfirmationModal = React.createRef();
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            detailsView: false,
            employeeId: 0,
            userId: 0,
            showModal: false,
            showModalForm: false,
            isNew: false,
            activeTab: Selected_Index.i_Zero,
            contentIndex:  Selected_Index.i_Zero,
            selectedCircuit: undefined,
            circuitId: 0,
            articleId: 0,
            createNew: false,
            viewDetailPage: false,
            headerTitle: "ArticleCatalogue",
            activeTabIcon: Selected_Index.i_Zero,
            buttonName:"Add Component",
            showSecondarybtn: false,
            showNotif: false,
            haveError: false,
            modalMessage: '',
            primaryTooltipLabel: "",
            secondaryTooltipLabel: "",
            articleComponent: [],
            isButtonDisabled: false, // <-- New state to control button
            isArticleAlreadyExist: false,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            confirmationModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            tabList : [
                {
                    type: "article",
                    title: "Article",
                    icon: "file-lines",
                    color: "font-blue",
                    isActive: true,
                    disabled: false
                },
                {
                    type: "component",
                    title: "Component",
                    icon: "layer-group",
                    color: "font-purple",
                    isActive: false,
                    disabled: false
                },
                {
                    type: "formula",
                    title: "Formula",
                    icon: "calculator-simple",
                    color: "font-green",
                    isActive: false,
                    disabled: false
                }
            ]
        }
    }
    onClickExtract = (e) => {
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractArticleCatalogue();
        }
    };
    componentDidMount() {
        this.props.getArticleCatalogue();
        this.props.getArticleCatalogueDropdownList();
    }
    componentWillUnmount() {
        this.props.setDefaultArticleCatalogue();
    }
    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }
    resizePage = (value) => {
        const { getArticleCatalogue, resizeArticleCataloguePage } = this.props;
        resizeArticleCataloguePage(value);
        getArticleCatalogue();
    }
    loading = () => {
        return (
            <NoSubscription />
        );
    }
    toLocaleLanguage = (key) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];
        return translation[locale][key];
    }
    applyFilter = (isApply) => {
        const { getArticleCatalogue, applyArticleCatalogueFilter } = this.props;
        applyArticleCatalogueFilter(isApply);
        getArticleCatalogue(0);
    }

    handleCloseForm = () =>{
        this.setState({
            viewDetailPage: false,
            articleId: 0,
            isArticleAlreadyExist: false,
            createNew: false
        }, this.changeHeaderTitle);
    };

    handleSelectedIndex = (index) => {
        this.setState({ contentIndex: index });
    };

    handleCreateNewAction = () => {
        const disableTabIndex = [1, 2];
        this.props.resetArticleCatalogueMilestoneForm();
        this.setState((prevState) => ({
            showModal: true,
            isNew: true,
            createNew: true,
            activeTabIcon: Selected_Index.i_Zero,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                disabled: disableTabIndex.includes(i)
            }))
        }));
        this.handleTabIcon(parseInt(Selected_Index.i_Zero))
    }

    changeHeaderTitle = () => {
        this.setState({
            headerTitle: this.state.viewDetailPage || this.state.createNew ? "ArticleCatalogue" : ""
        });
    };

    handleCreateNewConf(buttonType){
        if(buttonType==="ok")
        {
            this.setState({
                showModalForm: true,
                showModal: false,
                isNew: true,
                viewDetailPage: true,
                buttonName: "Save Changes",
                primaryTooltipLabel:"save_article_info",
                showSecondarybtn: false,
                articleComponent: [],
            })
        } else {
            this.setState({
                showModal: false,
                viewDetailPage: true
            })
        }
    };

    handleCloseFormModal = () => {
        this.setState({
            showModalForm: false,
            contentIndex: Selected_Index.i_Zero,
            isArticleAlreadyExist: false,
            isNew: false,
            articleId: 0
        });
    };

    onChangeExtractAlertMsg = (val) => {
        this.setState({ extractAlertMsg: val });
    };

    handleCreateNew = (buttonType) => {
        if (buttonType === "ok")
        {
            this.setState({
                articleId: 0,
                createNew: !this.state.createNew,
                showModal: false,
                buttonName: "Save Changes",
                showSecondarybtn: false,
                articleComponent: [],
            }, this.changeHeaderTitle);
        } else {
            this.setState({ showModal: false })
        }

    };

    handleTabIcon = (index) => {
        this.setState({ activeTabIcon: index })

        this.setState((prevState) => ({
            activeTabIcon: index,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                isActive: i === index
            }))
        }));
        
        switch(parseInt(index)) {
            case 0:
                return this.setState({ 
                    buttonName: this.state.articleId !== 0 ? "Save Changes" : 
                    (parseInt(this.props.articleCatalogueMilestoneForm.priceCalculationId === 1) ? "Save Changes" : "Add Component"), 
                        showSecondarybtn: false,
                        primaryTooltipLabel: (parseInt(this.state.articleId) !== 0)  ? "save_article_info" : "add_component",                        
                    });
            case 1:
                return this.setState({ 
                    buttonName: this.state.articleId !== 0 ? "Update Formula" : "Add Formula", 
                    showSecondarybtn: this.state.articleId !== 0 ? false : true,
                    primaryTooltipLabel: "add_formula",
                    secondaryTooltipLabel: "go_back_article"
                 });
            case 2:
                return this.setState({ 
                    buttonName: "Save Changes", 
                    showSecondarybtn: true,
                    primaryTooltipLabel: "save_article_details",
                    secondaryTooltipLabel: "go_back_component"
                 });
            default:
                return null
        }

    };

    handlePrimaryBtn = async (debitorId, validate = 1) => {
        const { buttonName, activeTabIcon } = this.state;
        const { articleCatalogueMilestoneForm, getArticleCatalogue } = this.props;
        const { PageNumber } = this.props.articleCatalogue?.articleCatalogueItems?.Pagination;
        if (buttonName === "Add Component") {
            this.handleTabIcon(parseInt(Selected_Index.i_One));
            this.setState((prevState) => ({
                tabList: prevState.tabList.map((tab) => ({ ...tab, disabled: false })),
            }));
        } else if (buttonName === "Add Formula" || buttonName === "Update Formula") {
            this.handleTabIcon(parseInt(Selected_Index.i_Two));
        } else if (buttonName === "Save Changes") {
            this.setState({
                isSaving: true,
                isArticleAlreadyExist: false
            });
            var result = await this.props.saveArticleCatalogueForm(articleCatalogueMilestoneForm.articleId, validate);
            this.setState({
                isSaving: false
            });

            if (result.success) {
                if (result.isValid) {
                    const confirmMessage = "Are you sure you want to save?";
                    const modalTitle = this.toLocaleLanguage("call_save", false);
                    var confirmAction = () => this.handlePrimaryBtn(articleCatalogueMilestoneForm.articleId, 0)
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.toggleSaveModal(false);
                    getArticleCatalogue(PageNumber);
                    if (result.message === "Article has been created.") {
                        this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);
                        this.handleCloseFormModal();
                    }
                    else if (result.message === "has been updated.") {
                        const tabNameMap = {
                            0: "Article",
                            2: "Component and Formula"
                        };

                        const tabName = tabNameMap[activeTabIcon] || "Article";
                        const finalMessage = `${tabName} ${result.message}`;
                        this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), finalMessage);
                        this.props.getArticleCatalogueMilestoneDetails(this.state.articleId);
                        if (tabName === "Component and Formula") {
                            this.handleDisableButton(true);
                        }

                    }
                    return;
                }
            }
            else {
                if (result.message === "Modifying Article required field will create a new Article. Would you like to continue?") {
                    const modalTitle = this.toLocaleLanguage("modal_confirmation_title", false);
                    confirmAction = () => this.handleCreateNewModifyAction()
                    this.toggleSaveModal(true, modalTitle, result.message, confirmAction)
                    return;

                }
                else if (result.message === "Article already exist.") {
                    this.toggleSaveModal(false);
                    this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                    this.setState({
                        isArticleAlreadyExist: true
                    });
                    return;
                }
                else {
                    this.toggleSaveModal(false);
                    this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message !== undefined ? result.message : this.toLocaleLanguage("article_not_saved_error", false));
                    return;
                }
            }
        }
    };

    handleDisableButton = (isDisabled, priceCalculation) => {
        const { buttonName, activeTabIcon } = this.state;
        if (this.state.articleId === 0) {
            if (priceCalculation === '1') {
                const disableTabIndex = [1, 2];
                this.props.resetArticleComponentMilestoneForm();
                this.setState((prevState) => ({
                    activeTabIcon: Selected_Index.i_Zero,
                    tabList: prevState.tabList.map((tab, i) => ({
                        ...tab,
                        disabled: disableTabIndex.includes(i)
                    }))
                }));        
                return this.setState({ buttonName: "Save Changes", showSecondarybtn: false, primaryTooltipLabel:"save_article_info", secondaryTooltipLabel: "" });
            }
            else if (priceCalculation === '2') {
                return this.setState({ buttonName: "Add Component", showSecondarybtn: false, primaryTooltipLabel: "add_component", secondaryTooltipLabel: "" });
            }
        }
        this.setState({ isButtonDisabled: isDisabled });
    };

    handleDisabledTab = (index) => {
        const disableTabIndex = [1, 2];
        const selectedIndex = parseInt(index);
        this.setState((prevState) => ({
            tabList: prevState.tabList.map((tab, i) => (
                i === selectedIndex ? { ...tab, disabled: disableTabIndex.includes(i) } : tab
            ))
        }));

    };

    handleSecondary = () => {
        this.handleTabIcon(this.state.activeTabIcon - 1);
    };

    handleRowClick = (isNew, item, hasLink) => {
        const disableTabIndex = item.PriceCalculation === 'Fix' ? [1, 2] : [];
        this.props.getArticleCatalogueMilestoneDetails(item.ArticleId);

        this.setState((prevState) => ({
            articleId: item.ArticleId,
            showModalForm: true,
            articleComponent: item.ArticleComponent,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                disabled: disableTabIndex.includes(i)
            }))
        }), () => {
            
            this.props.getArticleCatalogueMilestoneDetails(item.ArticleId);

            if (!isNew && item.ArticleId && hasLink && (item.Components != null)) {
                this.handleTabIcon(parseInt(Selected_Index.i_One));
            } else {
                this.handleTabIcon(parseInt(Selected_Index.i_Zero));
            }
        });
    };
    handleCloseNotif = () => {
        this.setState({ showNotif: false });
    };

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }
        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }
    handleCreateNewModifyAction = () => {
        const disableTabIndex = [1, 2];
        this.props.resetArticleComponentMilestoneForm();
        this.setState((prevState) => ({
            articleId: 0,
            isNew: true,
            createNew: true,
            articleComponent: [],
            activeTabIcon: Selected_Index.i_Zero,
            tabList: prevState.tabList.map((tab, i) => ({
                ...tab,
                disabled: disableTabIndex.includes(i)
            }))
        }));
        this.handleTabIcon(parseInt(Selected_Index.i_Zero))
        this.props.FormChange("articleCatalogueMilestoneForm.articleId", 0);
        this.setState({
            buttonName: (this.props.articleCatalogueMilestoneForm.priceCalculationId === 1 || this.props.articleCatalogueMilestoneForm.priceCalculationId === '1') ? "Save Changes" : "Add Component",
            showSecondarybtn: false,
        });
  
        this.toggleSaveModal(false);
    }
    render() {     
        const { showModalForm, activeTab, isNew, contentIndex, tabList, activeTabIcon, buttonName, showSecondarybtn, primaryTooltipLabel, secondaryTooltipLabel } = this.state;
        const { articleCatalogue
            , articleCatalogueMilestoneForm
            , getArticleCatalogue
            , sortArticleCatalogue
            , setArticleCatalogueColSearchStr
            , addArticleCatalogueFilter
            , removeArticleCatalogueFilter
            , saveArticleCatalogueCustomCols
            , $form } = this.props;
        const { Selected, Available, Default } = this.props.articleCatalogue.articleCatalogueItems.Columns;
        const initialRequired =
            articleCatalogueMilestoneForm?.articleNumber === '' ||
            articleCatalogueMilestoneForm?.articleName === '' ||
            articleCatalogueMilestoneForm?.serviceFamily === '' ||
            articleCatalogueMilestoneForm?.salesOrganizationId === 0 ||
            articleCatalogueMilestoneForm?.salesOrganizationId === '' ||
            articleCatalogueMilestoneForm?.countryId === 0 ||
            articleCatalogueMilestoneForm?.countryId === '' ||
            articleCatalogueMilestoneForm?.priceCalculationId === '' ||
            articleCatalogueMilestoneForm?.priceCalculationId === 0 ||
            articleCatalogueMilestoneForm?.vatGroupId === 0 ||
            articleCatalogueMilestoneForm?.chargeTypeId === 0 ||
            articleCatalogueMilestoneForm?.chargeCategoryId === 0 ||
            ((articleCatalogueMilestoneForm?.priceCalculationId === '1' || articleCatalogueMilestoneForm?.priceCalculationId === 1)  && (articleCatalogueMilestoneForm?.fixedFee === '' || articleCatalogueMilestoneForm?.fixedFee === null)) ||
            (articleCatalogueMilestoneForm?.isAlternateLogic === true && (articleCatalogueMilestoneForm?.additionalAttribute === '' || articleCatalogueMilestoneForm?.additionalAttribute === null));
        const { priceCalculationId, ...formFiltered } = $form.value;
        const { priceCalculationId: ignored, ...milestoneFiltered } = articleCatalogueMilestoneForm;
        const disableSaveChanges = isObjectEqual(formFiltered, milestoneFiltered) ? true : false;
        const disableButton = this.state.articleId === 0 ? initialRequired : (initialRequired || disableSaveChanges);
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingArticleCatalogueDashboardRW])
       
        return (
            <>
                <DetailsDashboard
                    // Filter Propertiess
                    data={articleCatalogue.articleCatalogueItems.TableFilterData}
                    translation={""}
                    addAction={addArticleCatalogueFilter}
                    removeAction={removeArticleCatalogueFilter}
                    applyAction={this.applyFilter}
                    isCreateButtonHidden={!articleCatalogue.isArticleCatalogueLoaded}
                    customClassName={"article-catalogue"}
                    //Create New
                    createNewAction={this.handleCreateNewAction}

                    //View Search Textbox
                    viewSearchAction={this.displaySearchBox}

                    //Customize Column
                    firstList={Available}
                    secondList={Selected}
                    defaultList={Default}
                    saveAction={saveArticleCatalogueCustomCols}

                    //Extract Button
                    extractAction={(e) => this.onClickExtract(e)}

                    //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                    >
                    {articleCatalogue.isArticleCatalogueLoaded ?
                        <TablePagination  
                            key={TABLE_PAGINATION_KEY.articleCatalogue}
                            classNameWrapper="overflow-auto"
                            columns={articleCatalogue.articleCatalogueItems.Headers}
                            pageList={articleCatalogue.articleCatalogueItems.Data}
                            pages={articleCatalogue.articleCatalogueItems.Pagination}
                            rowClickAction={(item, hasLink) => { this.handleRowClick(false, item, hasLink) }}
                            paginationAction={getArticleCatalogue}
                            onColumnClick={sortArticleCatalogue}
                            onColumnSearch={() => { getArticleCatalogue(0) }}
                            onColumnSearchChange={setArticleCatalogueColSearchStr}
                            isColSearchShow={this.state.displaySearch}
                            resizePage={this.resizePage}
                            totalPage={articleCatalogue.articleCatalogueItems.TotalEntries}
                            hideStatusIcon={true}
                        />
                    : this.loading()}
                </DetailsDashboard>
                    
                <ModalContainer
                    title="article_info"
                    show={showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={contentIndex === Selected_Index.i_One}
                    saveDetails={this.handlePrimaryBtn}
                    secondaryBtnFc={this.handleSecondary}
                    customClass="cost-allocation-details__modal modal-form__container article_detail__container"
                    disabled={(activeTabIcon === 0 || activeTabIcon === '0') ? disableButton : ((activeTabIcon === 1 || activeTabIcon === '0') ? false : (disableButton || this.state.isButtonDisabled))}
                    isReadAndWrite={isReadAndWrite}
                    buttonName={buttonName}
                    showSecondarybtn={showSecondarybtn}
                    primaryBtnTooltip={primaryTooltipLabel}
                    secondaryBtnTooltip={secondaryTooltipLabel}
                >

                    <div className="data-table">
                        <DetailContainer
                            renderTabContent={this.handleSelectedIndex}
                            urlIndex={activeTab}
                            tabListIcon={tabList}
                            onhandleIconClick={this.state.articleId !== 0 ? this.handleTabIcon : ''}
                            hideTabIcon={contentIndex === Selected_Index.i_One}
                            listTab={[
                                {
                                    "id": Selected_Index.i_Zero,
                                    "label": "Details",
                                    "hidden": false
                                },
                                {
                                    "id": Selected_Index.i_One,
                                    "label": "History",
                                    "hidden": false,
                                    "disable": isNew ? true : false
                                },

                            ]}
                        >

                            {contentIndex === Selected_Index.i_Zero &&
                                <ArticleDetails
                                activeTabIcon={activeTabIcon}
                                articleId={this.state.articleId}
                                onDisabledTab={this.handleDisabledTab.bind(this)}
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                                onDisableButton={this.handleDisableButton.bind(this)}
                                articleComponent={this.state.articleComponent || [] }
                                isArticleAlreadyExist={this.state.isArticleAlreadyExist}
                                />
                            }
                            {contentIndex === Selected_Index.i_One &&
                                <ArticleHistory
                                articleId={this.state.articleId}
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                            />
                            }

                        </DetailContainer>
                    </div>

                </ModalContainer>

                <ConfirmationNotificationModal
                    show={this.state.showModal}
                    message={MODAL_CUSTOM_MESSAGE.create_new_article}
                    title={'Add New'}
                    handleModal={this.handleCreateNewConf.bind(this)}
                    customClass={'comment-notification-modal modal-text-bold'}
                />

                <ConfirmationModal
                    ref={this.ConfirmationModal}
                    title={this.state.saveModal.title}
                    messageBody={this.state.saveModal.messageBody}
                    confirmAction={this.state.saveModal.confirmAction}
                    closeLabel={this.toLocaleLanguage("cancel_button")}
                    confirmLabel={this.toLocaleLanguage("yes_button")}
                    disabled={this.state.isSaving}
                /> 

                <NotificationModal
                    show={this.state.saveNotif.show}
                    title={this.state.saveNotif.title}
                    message={this.state.saveNotif.message}
                    handleModal={() => this.toggleSaveNotif(false)}
                    customClass={'comment-notification-modal notification-footer modal-text-bold confirmation-blur-background'}
                />   

            </>
        );
    }
}
export default withRouter(connect(
    state => {
        const { articleCatalogue,
            translation,
            articleCatalogueMilestone,
            form: { forms: { articleCatalogueMilestoneForm: { $form } } }
        } = state;
        const { articleCatalogueMilestoneForm } = state.form;
        return {
            translation
            , articleCatalogue
            , articleCatalogueMilestone
            , articleCatalogueMilestoneForm
            , $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, articleCatalogueActions, articleCatalogueMilestoneActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(ArticleCatalogue));